<template>
  <el-row :gutter="20">

    <el-col :lg="16" :md="14">
      <el-space direction="vertical" alignment="stretch" class="w-100">

        <el-alert
          v-if="pending_contact_requests && pending_contact_requests.length > 0"
          type="success"
          :closable="false"
          class="contact-request-alert"
        >
          <template #title>
            <h5 class="mb-0">
              <i class="fas fa-bell me-2"></i>
              您有 {{ pending_contact_requests.length }} 个新的联系请求
            </h5>
          </template>

          <el-card shadow="never" class="mt-3">
            <ul class="contact-request-list">
              <li v-for="req in pending_contact_requests" :key="req.id" class="p-3">
                <h6 class="mb-1">
                  来自: {{ req.requester_name }}
                  <small class="text-muted fw-normal">({{ req.requester_org }})</small>
                </h6>
                <p class="request-message">
                  "{{ req.message }}"
                </p>
                <div class="text-end">
                  <el-button
                    type="danger" plain
                    size="small"
                    :loading="req.isProcessing === 'reject'"
                    @click="handleRespondRequest(req.id, 'reject')">
                    拒绝
                  </el-button>
                  <el-button
                    type="success"
                    size="small"
                    :loading="req.isProcessing === 'approve'"
                    @click="handleRespondRequest(req.id, 'approve')">
                    同意
                  </el-button>
                </div>
              </li>
            </ul>
          </el-card>
        </el-alert>

        <el-card shadow="never">
          <template #header>
            <div class="card-header">
              <h5 class="mb-0">积分申请</h5>
              <el-button type="primary" @click="$router.push('/apply')">
                <i class="fas fa-plus-circle me-1"></i>
                提交新的积分申请
              </el-button>
            </div>
          </template>

          <h6 class="mb-3">我的申请记录</h6>
          <el-table :data="applications" stripe style="width: 100%" v-if="applications && applications.length > 0">
            <el-table-column prop="rule_description" label="申请规则" />
            <el-table-column label="提交日期" width="120">
              <template #default="scope">
                {{ new Date(scope.row.submission_date).toLocaleDateString() }}
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100" align="center">
              <template #default="scope">
                <el-tag :type="getStatusTagType(scope.row.status)">
                  {{ scope.row.status_display }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>

          <el-empty v-else description="您还没有提交过任何申请。" />
        </el-card>

        <el-card shadow="never">
          <template #header>
            <div class="card-header">
              <h5 class="mb-0">我的上传状态</h5>
            </div>
          </template>
          <el-table :data="my_resources" stripe style="width: 100%" v-if="my_resources && my_resources.length > 0">
            <el-table-column prop="title" label="资源标题" />
            <el-table-column label="上传日期" width="120">
              <template #default="scope">
                {{ new Date(scope.row.upload_date).toLocaleDateString() }}
              </template>
            </el-table-column>
            <el-table-column label="审批状态" width="100" align="center">
              <template #default="scope">
                <el-tag :type="scope.row.is_approved ? 'success' : 'warning'">
                  {{ scope.row.status_display }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="90" align="center">
              <template #default="scope">
                <el-button v-if="scope.row.is_approved" type="success" plain size="small" @click="downloadFile(scope.row.file)">
                  下载
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-empty v-else description="您还没有上传过任何资源。">
            <el-button type="primary" plain @click="$router.push('/resources/upload')">
              马上去上传
            </el-button>
          </el-empty>
        </el-card>

        <el-card shadow="never">
          <template #header>
            <h5 class="mb-0">最近积分账本</h5>
          </template>
          <ul class="list-group list-group-flush" v-if="recent_transactions && recent_transactions.length > 0">
            <li v-for="tx in recent_transactions" :key="tx.id" class="list-group-item d-flex justify-content-between align-items-center">
              <div>
                <p class="mb-0 fw-bold">{{ tx.description }}</p>
                <small class="text-muted">{{ new Date(tx.timestamp).toLocaleString() }}</small>
              </div>
              <el-tag :type="tx.points_change >= 0 ? 'success' : 'danger'">
                {{ tx.points_change > 0 ? '+' : '' }}{{ tx.points_change }}
              </el-tag>
            </li>
          </ul>
          <el-empty v-else description="暂无积分记录" />
        </el-card>

      </el-space>
    </el-col> <el-col :lg="8" :md="10">
      <div class="position-sticky" style="top: 1.5rem;">
        <el-card v-if="member" shadow="never">
          <template #header>
            <div class="card-header">
              <h5 class="mb-0">您的会员信息</h5>
            </div>
          </template>

          <div class="text-center mb-3">
            <h6 class="text-muted mb-1">当前总积分</h6>
            <h2 class="display-5 text-success fw-bold">{{ member.total_points }}</h2>
          </div>
          <el-divider />

          <el-descriptions :column="1" border>
            <el-descriptions-item label="姓名">{{ member.full_name }}</el-descriptions-item>
            <el-descriptions-item label="会员号">{{ member.member_id }}</el-descriptions-item>
            <el-descriptions-item label="会员类型">{{ member.member_type }}</el-descriptions-item>
            <el-descriptions-item label="政治面貌">
              {{ member.is_party_member ? '党员' : '群众' }}
            </el-descriptions-item>
          </el-descriptions>

          <el-button-group class="w-100 mt-3">
            <el-button class="w-50" @click="$router.push('/profile')">
              <i class="fas fa-pencil-alt me-1"></i> 编辑资料
            </el-button>
            <el-button class="w-50" @click="handleDownloadCertificate" :loading="isDownloading">
              <i class="fas fa-download me-1"></i>
              {{ isDownloading ? '生成中...' : '下载证书' }}
            </el-button>
          </el-button-group>
          <el-button type="danger" plain class="w-100 mt-2" @click="$router.push('/password')">
            <i class="fas fa-key me-1"></i> 修改密码
          </el-button>

        </el-card>
      </div>
    </el-col> </el-row> </template>

<script>
//
// <script> 部分完全保持不变
//
import axios from 'axios';

export default {
  name: 'DashboardView',
  data() {
    return {
      isLoading: true,
      member: null,
      recent_transactions: [],
      applications: [],
      isDownloading: false,
      my_resources: [],
      pending_contact_requests: [],
    };
  },
  async mounted() {
    const token = localStorage.getItem('authToken');
    if (!token) {
      this.$router.push('/login');
      return;
    }
    try {
      const response = await axios.get('/members/api/dashboard/', {
        headers: { 'Authorization': `Token ${token}` }
      });
      this.member = response.data.member;
      this.recent_transactions = response.data.recent_transactions;
      this.applications = response.data.applications;
      this.my_resources = response.data.my_resources;
      // 【修改】确保 V2.0 字段被正确读取
      this.pending_contact_requests = (response.data.pending_contact_requests || []).map(req => ({
        ...req,
        isProcessing: null // 'approve', 'reject', 或 null
      }));
      if (this.member) {
          localStorage.setItem('isFeePaid', this.member.is_fee_paid ? 'true' : 'false');
          localStorage.setItem('isPremiumMember', this.member.is_premium_member ? 'true' : 'false');
          localStorage.setItem('isStaff', response.data.is_staff ? 'true' : 'false');
      } else if (response.data.is_staff) {
          localStorage.setItem('isStaff', 'true');
          localStorage.removeItem('isFeePaid');
          localStorage.removeItem('isPremiumMember');
      } else {
          localStorage.removeItem('isFeePaid');
          localStorage.removeItem('isPremiumMember');
          localStorage.removeItem('isStaff');
      }
    } catch (error) {
      console.error('获取数据失败:', error);
      localStorage.removeItem('authToken');
      localStorage.removeItem('isFeePaid');
      localStorage.removeItem('isPremiumMember');
      localStorage.removeItem('isStaff');
      this.$router.push('/login');
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    // 【修改】为 el-table 返回 Element Plus 的 Tag 类型
    getStatusTagType(status) {
      if (status === 'APPROVED') return 'success';
      if (status === 'REJECTED') return 'danger';
      if (status === 'PENDING') return 'warning';
      return 'info';
    },

    // (handleDownloadCertificate 保持不变)
    async handleDownloadCertificate() {
      this.isDownloading = true;
      const token = localStorage.getItem('authToken');
      try {
        const response = await axios.get('/members/api/certificate/', {
          headers: { 'Authorization': `Token ${token}` },
          responseType: 'blob'
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '广东省青年科技创新研究会-会员证书.jpg');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载证书失败:', error);
        if (error.response && error.response.data.type === 'application/json') {
          try {
            const errorData = JSON.parse(await error.response.data.text());
            if (errorData.error) {
              alert(errorData.error);
            } else {
              alert('证书生成失败，请联系管理员。');
            }
          } catch(parseError) {
             alert('证书生成失败，无法解析错误信息。');
          }
        } else {
          alert('证书生成失败，请联系管理员。');
        }
      } finally {
        this.isDownloading = false;
      }
    },

    // 【新增】为下载按钮（表格）
    downloadFile(fileUrl) {
      // 这是一个简单的下载
      window.open(fileUrl, '_blank');
    },

    // (handleRespondRequest 保持不变)
    async handleRespondRequest(requestId, action) {
      const req = this.pending_contact_requests.find(r => r.id === requestId);
      if (!req) return;
      req.isProcessing = action;
      const token = localStorage.getItem('authToken');
      try {
        await axios.post(`/members/api/contact_requests/${requestId}/respond/`,
          { action: action },
          { headers: { 'Authorization': `Token ${token}` }
        });
        this.pending_contact_requests = this.pending_contact_requests.filter(r => r.id !== requestId);
      } catch (error) {
        console.error('响应请求失败:', error);
        alert("操作失败，请稍后再试。");
        req.isProcessing = null;
      }
    }
  }
};
</script>

<style scoped>
/* --- V4.0 样式优化版 --- */

/* (确保 Element Plus 的组件 100% 宽度) */
.w-100 {
  width: 100%;
}
.h-100 {
  height: 100%;
}

/* --- 【重点修改】卡片头部样式 --- */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0; /*稍微增加一点内边距*/
}

/* 让“我的申请记录”、“我的上传状态”等标题变大 */
.card-header h5 {
  font-size: 25px;  /* 【修改】原默认约14px，改为18px */
  font-weight: 700; /* 【修改】加粗 */
  color: #303133;   /* 【修改】加深颜色，更清晰 */
  margin-bottom: 0;
  line-height: 1.5;
}

/* 头部图标样式 */
.card-header .fas {
  font-size: 1.2rem; /* 图标也稍微放大 */
  color: var(--el-text-color-secondary);
  cursor: pointer;
  transition: color 0.3s;
}
.card-header .fas:hover {
  color: var(--el-color-primary);
}

/* --- 【新增】优化积分数字显示 --- */
.display-5 {
  font-size: 3.5rem; /* 【修改】让积分数字更大 */
  font-weight: bold;
  color: #67C23A;    /* 设为绿色，突出显示 */
  margin-bottom: 1rem;
}

/* --- 【新增】优化会员信息列表 (el-descriptions) --- */
:deep(.el-descriptions__label) {
  font-weight: 600;
  font-size: 15px; /* 标签文字调大 */
  color: #606266;
}
:deep(.el-descriptions__content) {
  font-size: 15px; /* 内容文字调大 */
  color: #303133;
}

/* (联系请求列表) */
.contact-request-alert :deep(.el-alert__content) {
  width: 100%;
}
.contact-request-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.contact-request-list li + li {
  border-top: 1px solid var(--el-border-color-lighter);
}
.request-message {
  background-color: var(--el-fill-color-light);
  padding: 10px 15px; /* 增加一点内边距 */
  border-radius: 4px;
  font-size: 15px;    /* 【修改】消息内容字体调大 */
  margin-bottom: 0.5rem;
  color: #606266;
}

/* (侧边栏“粘性”布局) */
.position-sticky {
  top: 1.5rem;
}

/* (修复 Element Plus 和 Bootstrap 的 CSS 冲突) */
.mb-0 { margin-bottom: 0 !important; }
.mb-1 { margin-bottom: 0.25rem !important; }
.mb-2 { margin-bottom: 0.5rem !important; }
.mb-3 { margin-bottom: 1rem !important; }
.mt-2 { margin-top: 0.5rem !important; }
.mt-3 { margin-top: 1rem !important; }
.mt-4 { margin-top: 1.5rem !important; }
.me-1 { margin-right: 0.25rem !important; }
.text-center { text-align: center; }
.text-end { text-align: right; }
.text-muted { color: var(--el-text-color-secondary); }
.text-success { color: var(--el-color-success); }
.text-danger { color: var(--el-color-danger); }
.fw-bold { font-weight: 600; }
.fw-normal { font-weight: 400; }

/* (保留 Bootstrap 的列表组样式，用于积分账本) */
.list-group {
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--el-card-border-radius);
}
.list-group-flush {
  border-radius: 0;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 1rem 1.25rem; /* 【修改】增加列表项的高度，不那么拥挤 */
  background-color: var(--el-color-white);
  border: 1px solid var(--el-border-color-lighter);
  font-size: 15px;       /* 【修改】列表文字调大 */
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.d-flex { display: flex; }
.justify-content-between { justify-content: space-between; }
.align-items-center { align-items: center; }
</style>